import React from "react";
import { connect } from "react-redux";
import { putExceptionList } from "../Actions/ExceptionManagementAPI";
class ExceptionEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exceptionList: {
        exceptionId: 0,
        name: '',
        type: '',
        isDeleted: false,
        modifiedBy: ''
      },
      Supplier: false,
      Maker: false
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRadioInputChange = this.handleRadioInputChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { ExceptionDetail, dispatch } = nextProps;
    if (ExceptionDetail && ExceptionDetail !== "") {
      prevState.exceptionList.name = ExceptionDetail.name;
      prevState.exceptionList.exceptionId = ExceptionDetail.exceptionId;
      if (ExceptionDetail.type.toLowerCase() === "supplier") {
        prevState.Supplier = true;
        prevState.exceptionList.type = 'supplier';
      } else {
        prevState.Maker = true;
        prevState.exceptionList.type = 'maker';
      }
      dispatch({ type: "ExceptionDetail", data: "" });
    }
  }

  UpdateException() {
    this.props.dispatch(putExceptionList(this.state.exceptionList));
    this.hideSidePanel();
  }

  handleInputChange(e) {
    this.state.exceptionList.name = e.target.value;
    this.setState({});
  }

  handleRadioInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "Supplier") {
      this.state.exceptionList.type = "Supplier";
      this.setState({ Supplier: true, Maker: false });
    } else if (nodeName === "Maker") {
      this.state.exceptionList.type = "Maker";
      this.setState({ Supplier: false, Maker: true });
    }
  }

  hideSidePanel = () => {
  //  this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push(`/Home/Management/Exception`);
  };

  render() {

    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              {/* <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
              >
                &larr; Return
                </button> */}
              <div className="card MM-card-header mt-2 mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                <div className="card-body">
                  <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                    Update Exception
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  <div className="col-lg-4">
                    <label className="form-label">Name </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="exceptionName"
                      placeholder="Name"
                      value={this.state.exceptionList.name}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">Type </label>
                    <br></br>
                    <div className="row">
                      <div className="col-sm-4">
                        <input
                          type="radio"
                          name="Supplier"
                          checked={this.state.Supplier}
                          onChange={(e) => this.handleRadioInputChange(e)}
                        ></input><span className="ml-1">Supplier</span>
                      </div>
                      <div className="col-sm-4">
                        <input
                          type="radio"
                          name="Maker"
                          checked={this.state.Maker}
                          onChange={(e) => this.handleRadioInputChange(e)}
                        ></input><span className="ml-1">Maker</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 pt-3">
                    <br></br>
                    <div className="search-btn-col" style={{ textAlign: "end" }}>
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.UpdateException()}
                      >
                        {" "}Update{" "}
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.hideSidePanel()}
                      >
                        {" "}Cancel{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ExceptionDetail: state.MasterScreenReducer.ExceptionDetail,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExceptionEdit);
